/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* global $ */
/* eslint-disable */

import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import TurnosSolicitudFilter from '../../../components/Telemedicina/TurnosSolicitudFilter/TurnosSolicitudFilter';
import CardHeader from '../../../components/Telemedicina/CardHeader/CardHeader';
import FilterLeft from '../../../components/Telemedicina/FilterLeft/FilterLeft';
import ListCards from '../../../components/Telemedicina/ListCards/ListCards';
import ModalBienvenida from '../../../components/Telemedicina/ModalBienvenida/ModalBienvenida';
import SinTurnosDisponibles from '../../../components/Telemedicina/SinTurnosDisponibles/SinTurnosDisponibles';
import IconCheck from '../../../../public/images/checked notif.png';
import * as telemedicinaActions from '../../../actions/telemedicinaActions';
import Loading from '../../../components/Loading/Loading';
import s from './TurnosSolicitud.css';
import ModalErrorDocumentoIntes from '../../../components/Telemedicina/ModalErrorDocumentoIntes/ModalErrorDocumentoIntes';
import validarDocumento from '../../../utils/validarDocumento';
import { HOST_SERVER, LOCALSTORAGE_AUTH_KEY } from '../../../constants';
import generateAbsoluteUrl from '../../../utils/generateAbsoluteUrl';
import AlertDisponibilidad from '../AlertDisponibilidad/AlertDisponibilidad.js'
import { CENTRO } from '../../../../src/constants/index'
import esEspontaneo from '../../../utils/turnUtils';
import TimeManipulation from '../../../utils/timeManipulation'

const MedicCard = props => {
  return(
    <div className="col-md-12" style={{ paddingLeft: '0', paddingRight: '0' }}>
      {/*props.primeraFechaDisponible &&
        props.horaDesde &&
        props.horaHasta
          ? <CardHeader 
              fechaCard={props.dateCard}
              turnosPorfecha={props.TurnosPorFecha}
            />
      : <Loading />*/}
      {props.TurnosPorFecha ? 
      <ListCards
        validarTurnoTomado={props.validarTurnoTomado}
        turnosPorfecha={props.TurnosPorFecha}
        specialityName={props.specialityName}
        fechaCard={props.dateCard}
      /> 
      : 
      <Loading />}
    </div>
  )
}

const initialState = {
  step: 1,
  email: '',
  buttonCards: 0,
  cardsData: [],
  cardsDataFilter:[],
  fecha: '',
  fechaSeleccionada: '',
  value: { min: 480, max: 1200 },
  maxValue: 1200,
  minValue: 480,
  desde: '',
  hasta: '',
  showEspontaneos: false,
  disabledButton: false
  // disabledButton: true //estabe asi
}
class TurnosSolicitud extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      ...initialState,
      areDoctorsOnline: null,
      specialityName: ''
    }

    this.setAreDoctorsOnline = this.setAreDoctorsOnline.bind(this);
    //this.setSpecialityName = this.setSpecialityName.bind(this);
    this.onVerDisponibilidadClick = this.onVerDisponibilidadClick.bind(this);

    this.onEspecialidadChange = this.onEspecialidadChange.bind(this);
    // this.onMotivoChange = this.onMotivoChange.bind(this);
    this.onIntegrantesChange = this.onIntegrantesChange.bind(this);
    this.getProgrammedTurn = this.getProgrammedTurn.bind(this);
    
  }

  setAreDoctorsOnline = (val) => {
    this.setState({areDoctorsOnline : val})
  }

  // setSpecialityName = (val) => {
  //   this.setState({specialityName : val})
  // }

  formatDate = (date, format) => {
    let dateFormat;
    const arrDate = date.split('/');
    const year = arrDate[2];
    const month =
      arrDate[1] < 10 && arrDate[1].substr(0, 1) !== '0'
        ? 0 + arrDate[1]
        : arrDate[1];
    const day =
      arrDate[0] < 10 && arrDate[0].substr(0, 1) !== '0'
        ? 0 + arrDate[0]
        : arrDate[0];
    if (format === 's') {
      dateFormat = year + month + day;
    } else {
      dateFormat = `${day}/${month}/${year}`;
    }
    return dateFormat;
  }

  dateMedicCard = date => {
    const year = date.substr(0, 4);
    const month = date.substr(4, 2);
    const day = date.substr(6, 8);
    const dateFormat = `${day}/${month}/${year}`;
    return dateFormat;
  }

  getDocumentos = integrantes => {
    const arrIntes = [];
    integrantes.forEach(option => {
      arrIntes.push({ documento: option.documento });
    });
    return arrIntes;
  }

  obtenerFechaHoy = () => {
    const hoy = new Date();
    let dd = hoy.getDate();
    let mm = hoy.getMonth() + 1;
    const yyyy = hoy.getFullYear();

    if (dd < 10) {
      dd = `0${dd}`;
    }

    if (mm < 10) {
      mm = `0${mm}`;
    }

    return `${dd}/${mm}/${yyyy}`;
  }

  componentDidMount(){
    $('#nav_main').css('z-index','4');
    // validar que tenga productos vinculados, sino redireccionar a vinculacion
    const datos = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH_KEY));
    let contra;
    let inte;
    if(datos){
      contra = datos.modelEspecifico.contra;
      inte = datos.modelEspecifico.inte;
    }

    if (contra === ' ') {
      window.location.href = `${HOST_SERVER}smgnewsite/prepaga/mis_productos.php?origen=barIzq`;
    }
    this.props.setHorarios('0800', '2000');
    newrelic.setCustomAttribute('contra', contra);
    newrelic.setCustomAttribute('inte', inte);
  }

  componentWillReceiveProps(props) { 
    if (this.props.TurnosPorFecha) {
      if (
        props.horaDesde !== this.props.horaDesde ||
        props.horaHasta !== this.props.horaHasta
      ) {
        this.props.filterTurnosPorHorario(
          props.horaDesde,
          props.horaHasta,
          this.props.TurnosPorFecha,
        );
      }
    }

    if (props.integrantes !== this.props.integrantes) {
      const arrDocumentos = this.getDocumentos(props.integrantes);
      for (let i = 0; i < arrDocumentos.length; i += 1) {
        if (!validarDocumento(arrDocumentos[i].documento)) {
          $('#ModalErrorDocumentoIntes').modal();
        }
      }
    }
  }

  componentWillMount(){
    this.resetState();
    //this.setState({disabledButton: true});
  }

  componentWillUnmount(){
    this.props.cleanListEspecialidad();
    this.props.cleanFechasDisponibles();
  }

  resetState(){
    this.setState(initialState)
  }

  next(step) {
    this.setState({
      step: step + 1,
    });
  }

  back(step){
    this.setState({
      step: step - 1,
    });
  }

  findDatePick = () => {
    if(this.state.fecha !== ''){
      const day = this.state.fecha.substring(0, 2);
      const month = this.state.fecha.substring(3, 5);
      const year = this.state.fecha.substring(6, 11);
      const dateFormat = `${Number(day)}/${Number(month)}/${year}`;

      let dateIndex = this.props.fechasDisponibles.indexOf(dateFormat);
      this.props.fetchTurnosPorFechaAsync(
        this.formatDate(this.props.fechasDisponibles[dateIndex], 's'),
        this.props.especialidades[1].espe,
        this.props.practica,
        this.props.prepaga,
      )
      .then(() => {
        let turnos = {
          date: this.props.fechasDisponibles[dateIndex],
          turnos:  this.props.TurnosPorFecha
        }
        let foundDate =  [turnos]
        dateIndex = dateIndex + 1
        if(this.state.cardsDataFilter.length > 0){
          let cardsDataFilter = foundDate
          cardsDataFilter = this.filterByTime(this.state.desde, this.state.hasta)
          this.setState({
            buttonCards: dateIndex,
            cardsData: foundDate,
            cardsDataFilter
        });
        }else{
          this.setState({
            buttonCards: dateIndex,
            cardsData : foundDate
          });
        }
      });
    }
  }

  fechaPicker = () => {
    const fechasDisponibles = this.props.fechasDisponibles;
    if (fechasDisponibles) {
      $('#calendario').show();
      $('#calendario')
        .datepicker({
          format: 'dd/mm/yyyy',
          autoclose: true,
          language: 'es',
          beforeShowDay(date) {
            const onlyThisDates = fechasDisponibles;
            let jsonReturn;
            const day = `${date.getDate()}/${date.getMonth() +
              1}/${date.getFullYear()}`;
            if (onlyThisDates.indexOf(day) !== -1) {
              jsonReturn = {
                enabled: true,
                tooltip: 'Seleccionar fecha',
              };
            } else {
              jsonReturn = {
                enabled: false,
                tooltip: 'Fecha no disponible',
              };
            }
            return jsonReturn;
          },
        })
        .on('changeDate', e => {
          $('#fechaTurno').val(
            this.formatDate(e.date.toLocaleDateString(), 's'),
          );
          if (
            this.formatDate(this.state.fechaSeleccionada, 's') !==
            this.formatDate(e.date.toLocaleDateString(), 's')
          ) {
            $('#fechaTurno').click();
          }
          let fecha = this.formatDate(e.date.toLocaleDateString(), 'h')
          this.setState({fecha}, () => this.findDatePick());
        });
    } else {
      $('#calendario').datepicker('remove');
    }
  }

  formatearHora = paramHora => {
    let hora = paramHora;
    const min = Math.floor(hora / 60);
    hora = Math.round(Math.abs(hora) % 60);
    return `${min}:${hora < 10 ? `0${hora}` : hora}`;
  }

  onChangeHorario = value => {
    const horaDesdeFormat = this.formatearHora(value.value.min).replace(
      ':',
      '',
    );
    const horaHastaFormat = this.formatearHora(value.value.max).replace(
      ':',
      '',
    );
    const horaDesde =
      horaDesdeFormat < 1000 ? 0 + horaDesdeFormat : horaDesdeFormat;
    const horaHasta =
      horaHastaFormat < 1000 ? 0 + horaHastaFormat : horaHastaFormat;
      let cardDataFiltradoPorTurno = this.filterByTime(horaDesde, horaHasta)
      this.setState({cardsDataFilter: cardDataFiltradoPorTurno})
  }

  onClickHorarioChange = obj => {
    const horaDesdeFormat = this.formatearHora(obj.min).replace(':', '');
    const horaHastaFormat = this.formatearHora(obj.max).replace(':', '');
    const horaDesde =
      horaDesdeFormat < 1000 ? 0 + horaDesdeFormat : horaDesdeFormat;
    const horaHasta =
      horaHastaFormat < 1000 ? 0 + horaHastaFormat : horaHastaFormat;

      let cardDataFiltradoPorTurno = this.filterByTime(horaDesde, horaHasta)

    this.setState({ 
      value: obj,
      cardsDataFilter: cardDataFiltradoPorTurno,
      desde: horaDesde,
      hasta: horaHasta
    });
  }

  setHora = value => {
    this.setState({ value })
  }

  filterByTime = (desde, hasta, turnos) =>{
    if(this.state.cardsData.length > 0){
      if(turnos){
        turnos = JSON.parse(JSON.stringify(turnos))
      }else{
        turnos = JSON.parse(JSON.stringify(this.state.cardsData))
      }

      let cardDataFiltradoPorTurno = turnos.map(turno => {
      
        let nuevosTurnos = turno.turnos.map(turnoPorMedico => {
          
          let horarios = turnoPorMedico.horarios

          const filtered = horarios.filter(
            horario =>
              horario.replace(':', '') >= desde &&
              horario.replace(':', '') < hasta,
          );
            turnoPorMedico.horarios = filtered
            return turnoPorMedico
          
        })
        turno.turnos = nuevosTurnos
        return turno
      })
      return cardDataFiltradoPorTurno
    }   
  }

  turnoVencido = pDate => {
    const year = pDate.substring(0, 4);
    const month = pDate.substring(4, 6);
    const day = pDate.substring(6, 8);
    const hour = pDate.substring(8, 10);
    const min = pDate.substring(10, 12);
    const dateFormated = `${year}-${month}-${day} ${hour}:${min}`;
    const date = moment(dateFormated);
    return  moment().isAfter(moment(date).add(10, 'minutes'));
  }

  getProgrammedTurn = (turns) => {
    const programmedTurn =  turns.filter(turn => turn.centro === CENTRO && !esEspontaneo(turn.prestador));
    return programmedTurn.length ? programmedTurn[programmedTurn.length - 1] : undefined;
  }

  validarTurnoTomado = fecha => {
    let inte = '';
    let prepaga = '';
    const datos = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH_KEY));
    const datosInteSelected = JSON.parse(localStorage.getItem('inteSelected'));
    const contra = datos.modelEspecifico.contra;
    if(datosInteSelected){
      inte = datosInteSelected.inte;
      prepaga = datosInteSelected.prepaga;
    }
    
    const token = datos.token;
    const dataTurnoTomado = {
      token,
      fechaDesde: fecha,
      fechaHasta: fecha,
      contra,
      prepaga,
      intes: [{ inte }],
      tipo: 'CMA',
    };
      return fetch(`${generateAbsoluteUrl()}/api/telemedicinaTurnos`, {
        method: 'POST',
        body: JSON.stringify(dataTurnoTomado),
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
      })
        .then(res => res.json())
        .then(turns => {
          // const filtered = response.filter(turno => turno.centro === CENTRO);
          // let ultimoProgramado = filtered.filter( e =>  e.titular.nombreAbre !== 'CLINICO GENERICO')
          const programmedTurn = this.getProgrammedTurn(turns)
          // ultimoProgramado = ultimoProgramado[ultimoProgramado.length - 1]
          // const ultimoTurno = filtered.length > 0 ? filtered[filtered.length - 1] : undefined;
          
          let showEspontaneo = (
            !programmedTurn || 
              (
                programmedTurn.idEspecialidad === $('#especialidad').val()
                &&
                  (!TimeManipulation.hourDifferenceLessThan(programmedTurn.fechaDesde, moment(), 1)
                  ||
                  this.turnoVencido(programmedTurn.fechaDesde)
                  )
              )
            );
            const showModal = programmedTurn && !this.turnoVencido(programmedTurn.fechaDesde)
            return { showEspontaneo, showModal };
        }).catch(error => console.error('Error:', error));
  }

  stateDisableButton(){
    if(this.props.stateEspecialidades && this.props.stateMotivo){
          this.setState({
            disabledButton: false,
          });
    }
  }

  onVerDisponibilidadClick() {
    // const especialidad = $('#especialidad').val();  
    // this.props.fetchPracticas(especialidad).then(
    //   res => this.props.fetchTurnWaitingTime(especialidad, this.props.prepaga,res[0].practica)
    //   .then(obj => obj)
    // );
    // this.props.cleanTurnosPorFecha();
    // $('#especialidad option[value=0]').hide();
    // this.props.fetchEmail();

    // this.validarTurnoTomado(this.formatDate(this.obtenerFechaHoy(), 's'))
    // .then(res => res)
    // .then(res => {
      
    //   this.setState({ showEspontaneos: res.showEspontaneo, disabledButton: false });
    // })
    // .catch(error => console.error('Error:', error));

    // this.setState({
    //   disabledButton: true,
    // });
     const especialidad = $('#especialidad').val();
     this.props.motivoAdd(especialidad)
     .then((data)=>{
      let motivo = this.props.motivos && this.props.motivos['id_motivo_consulta'];
      this.props.fetchMotivo(motivo);
     })
     .catch((err)=>{console.error(err)})
    
    this.props.fetchEspecialidad(especialidad); 
    this.setState({ showEspontaneos: true, disabledButton: false });
  }

  onEspecialidadChange() {
    let selectedName = $('#especialidad').find('option:selected').attr("name");
    //this.props.setSpecialityName(selectedName)
    const especialidad = $('#especialidad').val();
    
    if(selectedName === 'Seleccione especialidad'){
      this.props.stateEspecialidades(false);
      return;
    }
    //Aca va un then catch
    this.props.motivoAdd(especialidad)
    .then((data)=>{
      setTimeout(() => {   
        console.log('pase por aca')
        this.props.stateEspecialidades(true);
        this.props.fetchEspecialidad(especialidad);
        this.props.stateMotivo(true);
        this.stateDisableButton();
        let motivo = this.props.motivos && this.props.motivos['id_motivo_consulta'];
        //let motivo = this.props.motivos;
        this.props.fetchMotivo(motivo);
      }, 1500); 
    })
    .catch((err)=>{console.error(err)})
    if (especialidad === '0') {
      this.props.cleanList();
    }
  }

  // onMotivoChange(){
  //   let selectedName = $('#motivo').find('option:selected').attr("name");
  //   const motivo = $('#motivo').val();
  //   if(selectedName === 'Seleccione motivo'){
  //     this.props.stateMotivo(false);
  //     return;
  //   }
  //       this.props.stateMotivo(true);
  //       this.props.fetchMotivo(motivo);
  //       this.stateDisableButton();
  //   if ( motivo === '0') {
  //     this.props.cleanList();
  //   }
  // }
  

  onIntegrantesChange(selectValue) {
    if ($('#selectIntegrantes').val() !== '') {
      const selected = $('#selectIntegrantes').find('option:selected');
      const authData = localStorage.getItem('inteSelected');
      const authJson = JSON.parse(authData);
      if (authJson && selected.data()) {
        authJson.credencial = selected.data('credencial');
        authJson.edad = selected.data('edad');
        authJson.fechanacimiento = selected.data('fechanacimiento');
        authJson.inte = $('#selectIntegrantes').val();
        authJson.nombrecompleto = selected.data('nombrecompleto');
        authJson.nrodoc = selected.data('nrodoc');
        authJson.prepaga = selected.data('prepaga');
        authJson.sexo = selected.data('sexo');
        authJson.tipodoc = selected.data('tipodoc');

        localStorage.setItem('inteSelected', JSON.stringify(authJson));
      }
    } else {
      localStorage.setItem('inteSelected', JSON.stringify(selectValue));
    }

    this.props.setIntegranteSeleccionado($('#selectIntegrantes').val());
    $('#especialidad option[value=0]').show();
    this.props.cleanList();
    this.props.cleanListEspecialidad();
    this.props.cleanFechasDisponibles();
    this.resetState();
    
    if ($('#selectIntegrantes').val() === '') {
      //Aca va un then catch
      this.props.fetchEspecialidades(selectValue.sexo, selectValue.edad)
      console.log('especialidades pase')
    } else {
      const selected = $('#selectIntegrantes').find('option:selected');
      this.props.fetchEspecialidades(
        selected.data('sexo'),
        selected.data('edad'),
      )
      // .then((data)=>{
      //   console.log('especialidades',this.props.especialidades)
      // })
    }
  }
//especialidadOptions
  render(){
    let cardsData = this.state.cardsDataFilter.length > 0 ? this.state.cardsDataFilter: this.state.cardsData 
    let alertTurnos = 1;
    let hayTurnos = true;
    let body = '';
    let componentCard = '';

    const fechaHoy = this.obtenerFechaHoy();
    const espontaneo = this.props.espontaneo;
    const fechaPrimerTurno = this.props.primerTurno;

    // if (fechaPrimerTurno && espontaneo) {
    //   // muestro el alert espontaneo con boton a videollamada
    //   if (espontaneo.fecha) {
    //     alertTurnos = 1; 
    //   } else {
    //     // muestro el alert no hay turnos para hoy
    //     if (fechaPrimerTurno !== fechaHoy) {
    //       alertTurnos = 2; 
    //     }
    //     // muestro el alert hay turnos para hoy
    //     if (fechaPrimerTurno === fechaHoy) {
    //       alertTurnos = 3; 
    //     }
    //     // muestro pantalla no turnos disponibles
    //     if (fechaPrimerTurno === '0') {
    //       hayTurnos = false; 
    //     }
    //   }
    // }
    if (hayTurnos) {
      componentCard = (
      <div className="row">
            {this.props.fechasDisponibles && this.state.cardsData.length > 0 &&
              <div className="col-md-3">
                <FilterLeft
                  formatDate={this.formatDate}
                  fechasD={this.props.fechasDisponibles}
                  load={this.loadeMoreCards}
                  change={this.setHora}
                  formatearHora={this.formatearHora}
                  value={this.state.value}
                  maxValue={this.state.maxValue}
                  minValue={this.state.minValue} 
                  onChangeHorario={this.onChangeHorario}
                  onClickHorarioChange={this.onClickHorarioChange}
                  changeDate={this.changeDate}
                  fecha={this.state.fecha}
                  fechaPicker={this.fechaPicker}
                  fechaHeader={this.props.primeraFechaDisponible}
                  horaDesde={this.props.horaDesde}
                  horaHasta={this.props.horaHasta}
                /> 
              </div>
            }
        <div className="col-md-9">
          <AlertDisponibilidad 
             showEspontaneos={this.state.showEspontaneos}
            // espontaneo={espontaneo}
            //Dscomente alertTurnos
             //alertTurnos={alertTurnos}
            // especialidad={this.props.turnos}
             validaciones={this.props.showValidacionesTecnicas}
            // areDoctorsOnline={this.state.areDoctorsOnline}
            // specialityName={this.state.specialityName}
          />
            
            {
              this.props.fechasDisponibles && this.state.cardsData.length > 0 &&
                cardsData.map((e,index) => {
                  return(
                    <div key={index}>
                      <MedicCard
                        validarTurnoTomado={this.validarTurnoTomado}
                        dateCard={e.date}
                        primeraFechaDisponible={e.date}
                        horaDesde={this.props.horaDesde}
                        horaHasta={this.props.horaHasta}
                        specialityName={this.state.specialityName}
                        TurnosPorFecha={e}
                      />
                    </div>
                  );
                })
            }
        </div>
      </div>
      );
    }
    // ALERTS
    if (hayTurnos) {
      body = (
        <div>
          <TurnosSolicitudFilter
            onVerDisponibilidadClick={this.onVerDisponibilidadClick}
            onIntegrantesChange={this.onIntegrantesChange}
            onEspecialidadChange={this.onEspecialidadChange}
            onMotivoChange={this.onMotivoChange}
            setAreDoctorsOnline={this.setAreDoctorsOnline}
            //setSpecialityName={this.setSpecialityName}
            disabledButton={this.state.disabledButton}
          />
          {alertTurnos > 0 ? componentCard : ''}
        </div>
      );
    } else {
      body = (
        <div>
          <TurnosSolicitudFilter
            setAreDoctorsOnline={this.setAreDoctorsOnline}
            //setSpecialityName={this.setSpecialityName}
            onIntegrantesChange={this.onIntegrantesChange}
          />
          <SinTurnosDisponibles />
        </div>
      );
    }
    return (
      <div>
        <ModalErrorDocumentoIntes />
        {body}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  stateMotivo: state.telemedicina.stateMotivo,
  fechasDisponibles: state.telemedicina.fechas_disponibles,
  primerTurno: state.telemedicina.primer_turno,
  espontaneo: state.telemedicina.espontaneo,
  TurnosPorFecha: state.telemedicina.turnos_por_fecha,
  primeraFechaDisponible: state.telemedicina.primera_fecha_disponible,
  horaDesde: state.telemedicina.horaDesde,
  horaHasta: state.telemedicina.horaHasta,
  integrantes: state.integrantes,
  turnos: state.turnos,
  practica: state.telemedicina.practica,
  prepaga: state.telemedicina.prepaga, 
  especialidades: state.turnos.especialidadOptions,
  stateEspecialidades: state.telemedicina.stateEspecialidades,
  id_motivo:state.telemedicina.id_motivo,
  motivos:state.telemedicina.motivos
});

export default connect(mapStateToProps, telemedicinaActions)(
  withStyles(s)(TurnosSolicitud),
);



// WEBPACK FOOTER //
// ./src/components/Telemedicina/TurnosSolicitud/TurnosSolicitud.js